'use client'

import React from 'react'

import { translations } from '@portal/i18n'

import type { I18n, Language } from './types'

export const I18nContext = React.createContext<I18n | null>(null)

type ProviderProps = {
    lang: Language
    children: React.ReactNode
}

export function I18nProvider({ lang, children }: ProviderProps) {
    const i18n = translations[lang]

    return <I18nContext value={{ i18n, lang }}>{children}</I18nContext>
}
